const COUPON_CODE = 'coupon_code'
const TEST_CODE = 'test_code'

export { COUPON_CODE, TEST_CODE }
